@if (modalService.activeModal(); as modal) {
<div class="fixed inset-0 z-120 flex items-center justify-center p-4 font-[Nunito]">
  <!-- Dialog panel -->
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm animate-[fadeIn_.5s_ease]"></div>
  @if(modalService.activeModal()?.variante === 'dialog') {
  <div
    class="relative bg-smartsheep-warm200 rounded-md shadow max-w-sm md:max-w-lg w-full overflow-hidden animate-[scaleIn_22s_cubic-bezier(0.34,1.56,0.64,1)">
    <!-- Body -->

    <div class="px-3 pt-6 pb-4">
      <div class="flex items-start gap-4">
        <!-- Icon -->
        <div>
          @switch (modalService.activeModal()?.type) { @case ('danger') {
          <span
            class="w-8 h-8 flex items-center justify-center text-xl shrink-0 border-mksoft-red rounded-[9px] border">
            <svg class="w-4 h-4 text-red-700/80">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-trash2-icon lucide-trash-2">
                <path d="M10 11v6" />
                <path d="M14 11v6" />
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                <path d="M3 6h18" />
                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
              </svg>
            </svg>
          </span>
          } @case ('warning') {
          <span
            class="w-8 h-8 flex items-center justify-center text-xl shrink-0 border-[#E76F51] rounded-[9px] border">
            <svg class="w-4 h-4 text-[#E76F51]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-triangle-alert-icon lucide-triangle-alert">
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </svg>
            </svg>
          </span>
          } @case ('info') {
          <svg class="w-7 h-7 text-blue-700"></svg>
          } @default {
          <span
            class="w-8 h-8 flex items-center justify-center text-xl shrink-0 border-mksoft-green rounded-[9px] border">
            <svg class="w-4 h-4 text-mksoft-green">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-circle-check-icon lucide-circle-check">
                <circle cx="12" cy="12" r="10" />
                <path d="m9 12 2 2 4-4" />
              </svg>
            </svg>
          </span>
          } }
        </div>

        <!-- Text -->
        <div class="flex-1 min-w-0 pt-0.5">
          <p
            class="text-[16px] font-extrabold leading-tight mb-1"
            [class.text-mksoft-red]="modal.type === 'danger'"
            [class.text-[#E76F51]]="modal.type === 'warning'"
            [class.text-mksoft-green]="modal.type === 'success' || !modal.type">
            {{ modal.title }}
          </p>
          <p class="text-[11px] leading-relaxed text-mksoft-subtitle">{{ modal.message }}</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-7 pt-2 pb-4 flex justify-end gap-2.5">
      <button
        (click)="modalService.close()"
        class="cursor-pointer flex-1 sm:flex-none px-3 py-2 text-sm font-semibold text-gray-600 bg-smartsheep-warm100 hover:bg-gray-300 rounded-lg transition-colors">
        {{ modal.cancelText || 'Abbrechen' }}
      </button>

      <button
        (click)="modalService.confirm()"
        [class.bg-mksoft-red]="modal.type === 'danger'"
        [class.hover:bg-red-800]="modal.type === 'danger'"
        [class.bg-[#E76F51]]="modal.type === 'warning'"
        [class.bg-mksoft-green]="modal.type === 'success' || !modal.type"
        class="cursor-pointer flex-1 sm:flex-none px-3 py-2 text-sm font-semibold text-white rounded-lg shadow-md transition-all active:scale-95">
        {{ modal.confirmText || 'Bestätigen' }}
      </button>
    </div>
  </div>
  } @if(modalService.activeModal()?.variante === 'editor') {
  <div class="fixed inset-0 z-120 flex items-center justify-center p-4">
    <!-- Dialog panel -->
    <div class="absolute inset-0 bg-gray-600/50 backdrop-blur-xs animate-[fadeIn_.5s_ease]"></div>
    <ng-container *ngComponentOutlet="modalService.activeModal()?.component"></ng-container>
  </div>
  }
</div>
}
